<template>
  <div>
    <h2 v-if="!responseMsg" class="h1 color-white mb-4">
      <span class="yellow">Discover tattooers</span> traveling to your area.
      Receive selected news from Coal.
    </h2>
    <form v-if="!responseMsg" class="newsletter-form" @submit.prevent disabled>
      <div class="email">
        <b-row>
          <b-col sm="12" class="column-form">
            <p class="white column-label">MY EMAIL IS:</p>
            <b-input-group class="mt-3 email">
              <b-form-input
                type="text"
                aria-label="My email is"
                ref="emailInput"
                v-model="email"
                placeholder="My email address"
                autocomplete="email"
                autocorrect="off"
                autocapitalize="none"
              />
              <b-input-group-append is-text class="pl-3">
                <svg svg-inline="" class="icon" @click="resetEmail" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15"><path fill="#969696" d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.707-7.5l2.829-2.828-.708-.708L7.5 6.793 4.672 3.964l-.708.708L6.793 7.5l-2.829 2.828.708.708L7.5 8.207l2.828 2.829.708-.708L8.207 7.5z"/></svg>
              </b-input-group-append>
            </b-input-group>
            <p v-if="showEmailError" class="red mt-2">{{ errors.email }}</p>
          </b-col>
        </b-row>
      </div>

      <div class="mt-5 location">
        <b-row>
          <b-col sm="12" class="column-form">
            <p class="white column-label">MY LOCATION IS:</p>
            <div class="mt-3">
              <SearchCity :resetOnSetPlace="false" :emitCityName="true" @select="selectCity" />
            </div>
            <p v-if="showCityError" class="red mt-2">{{ errors.city }}</p>
          </b-col>
        </b-row>
      </div>

      <div class="mt-4">
        <b-row>
          <b-col sm="12" class="column-label"></b-col>
          <b-col sm="12" class="column-form">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="optin" v-model="optin" />
              <label class="custom-control-label" for="optin">
                I accept to receive updates from Coal
              </label>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" class="column-label"></b-col>
          <b-col sm="12" class="column-form">
            <b-button type="submit"
              variant="coal-yellow"
              class="big submit"
              :disabled="!optin || submitting"
              @click="submit"
            >
              Receive our travel alerts
            </b-button>
            <p v-if="errors.form" class="red mt-4">{{ formatMailchimpError }}</p>
          </b-col>
        </b-row>
      </div>
    </form>

    <div v-if="responseMsg" class="mt-3">
      <h3 class="h1 color-white mb-2">
        You've successfully<br v-if="$root.isMobile"/> signed up.
      </h3>
      <p class="mb-4">{{ responseMsg }}</p>
      <b-button variant="coal-yellow"
        class="big"
        @click="$router.go(-1)"
      >
        Continue exploring
      </b-button>
    </div>
  </div>
</template>

<script>
import { validate } from 'email-validator';
import SearchCity from './SearchCity.vue';
import addToMailchimp from '../helpers/addToMailchimp';

export default {
  name: 'Newsletter',
  components: {
    SearchCity,
  },
  data() {
    return {
      email: '',
      city: '',
      optin: false,
      submitting: false,
      response: {},
      responseMsg: null,
      errors: {
        email: null,
        city: null,
        form: null,
      },
    };
  },
  computed: {
    showEmailError() {
      return this.errors.email;
    },
    showCityError() {
      return this.errors.city;
    },
    formatMailchimpError() {
      if (this.response.msg.includes('too many')) {
        return 'Too many recent signup requests. Try again later.';
      }

      if (this.response.msg.includes('already subscribed')) {
        return 'You\'re already subscribed.';
      }

      return 'Something went wrong. Try again later.';
    },
  },
  methods: {
    resetEmail() {
      this.email = '';
      this.$refs.emailInput.focus();
    },
    validateForm() {
      let error = false;
      this.errors = {
        email: null,
        city: null,
      };

      if (this.email === '') {
        this.errors.email = 'Email address required';
        error = true;
      } else if (!validate(this.email)) {
        this.errors.email = 'Wrong email address format';
        error = true;
      }

      if (this.city === '') {
        this.errors.city = 'Your city is required';
        error = true;
      }

      return !error;
    },
    selectCity(city) {
      this.city = city;

      window.setTimeout(() => {
        let offset = 0;

        if (this.$root.isMobile) {
          offset = this.$refs.scrollTo.offsetHeight + this.$refs.scrollTo.offsetTop;
          offset += document.getElementsByTagName('header')[0].offsetHeight;
          offset += 40;
        }

        window.scrollTo(0, offset);
      }, 100);
    },
    submit() {
      return false
    
      if (!this.validateForm()) {
        return false;
      }

      this.submitting = true;

      addToMailchimp(this.email, {
        LOCATION: this.city,
      }).then((data) => {
        this.submitting = false;
        this.response = data;

        if (data.result === 'success') {
          this.responseMsg = data.msg;
        } else {
          this.errors.form = data.msg;
        }
      });

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variables";

.newsletter-form {
  @media screen and (min-width: 991px) {
    max-width: 400px;
  }
}

.segment {
  margin-top: 50px;
}

.icon.selected path {
  fill: $white;
}

.input-group {
  border-bottom: 1px solid $grey;
  padding-bottom: 5px;

  .input-group-text {
    padding-left: 0px;
    padding-right: 0px;
    background: transparent;
    color: $dark-grey;
    border: 0;
  }

  input {
    // Used to prevent the animation of the -webkit-autofill styles being overwriten
    transition: none !important;
    background: transparent !important;
    border: 0;
    padding-left: 2px;
    padding-right: 0px;
    color: $white;

    outline: none;

    &::placeholder {
      color: #505050;
    }
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active  {
    outline: none;
    box-shadow: 0 0 0 30px $black inset !important;
    -webkit-text-fill-color: $white !important;
  }
}

.yellow-link {
  color: $yellow;
  text-decoration: underline;
  cursor: pointer;
}

.custom-checkbox {
  padding-left: 2.5rem;
  cursor: pointer;

  .custom-control-label::before,
  .custom-control-label::after {
    width: 24px;
    height: 24px;
    transform: translateY(-50%);
    top: 50%;
    left: -2.5rem;
    border-radius: 0;
    border: 0;
  }

  .custom-control-label::before {
    background: transparent url("../assets/svg/checkbox_off.svg") no-repeat 0 0;
  }

  .custom-control-input:checked ~ .custom-control-label::after {
    background: transparent url("../assets/svg/checkbox_on.svg") no-repeat 0 0;
  }

  .custom-control-input ~ .custom-control-label::before,
  .custom-control-input:checked ~ .custom-control-label::before {
    border-color: transparent;
    background-color: transparent;
    box-shadow: none;
  }
}

.submit {
  margin-top: 32px;
}

.custom-control-label {
  color: #787878;
}

.mobile {
  .header {
    background-color: $light-black;
    margin: 0 -$side-margin;
    margin-bottom: 40px;
    padding: 38px 24px 36px 24px;
  }

  .social-right {
    text-align: right;
    color: #787878;
  }
}

.desktop {
  .registration {
    margin-top: 20px;
  }

  .no-marg {
    margin: 0;
  }

  .title {
    height: 110px;
    border-bottom: 1px solid #464646;
    margin-bottom: 40px;
  }

  .column-left {
    max-width: 260px;
    padding: 0;
    padding-left: 15px;
  }

  .column-separator {
    max-width: 90px;
  }

  .column-right {
    max-width: 476px;
    padding: 0;
  }

  .order-first {
    max-width: 290px;
    padding: 0;
  }

  .order-last {
    max-width: 290px;
    padding: 0;
  }

  .column-sub-separator {
    max-width: 60px;
  }

  .bordered {
    border: 0;
  }

  .selection {
    margin-top: 80px;
  }

  .column-label {
    font-size: 14.4px;
  }

  .social-left {
    min-width: 100%;
    font-size: 14.4px;

    p {
      margin-bottom: 10px;
    }
  }

  .custom-control-label {
    font-size: 14.4px;
    color: #787878;
  }

  .social-right {
    font-size: 12.8px;
  }

  .submit {
    margin-left: 0 !important;
  }

  .submit,
  .errors {
    margin-left: 40px;
  }
}
</style>
